module["exports"] = [
  "Пан",
  "Пані"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/uk/name/prefix.js
 ** module id = 1072
 ** module chunks = 0
 **/